import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { AircraftStore } from '../../../store/aircraft/state/aircraft.store';
import { AircraftQuery } from '../../../store/aircraft/state/aircraft.query';
import { Aircraft } from '@ogn-tracker/common/build/aircraft';
import { AircraftService } from '../../../store/aircraft/state/aircraftService';
import { BeaconType } from '@ogn-tracker/common/build/enum/beacon-type';
import { SubSink } from 'subsink';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'app-aircraft-popup',
  templateUrl: './aircraft-popup.component.html',
  styleUrls: ['./aircraft-popup.component.scss']
})
export class AircraftPopupComponent implements OnInit, OnDestroy {
  aircrafts$ = this.query.select('aircrafts');

  @ViewChild('aircraftTab')
  aircraftTab: MatTabGroup;

  newAircraft = this.fb.group({
    beaconType: ['', Validators.required],
    deviceId: ['', Validators.required],
    aircraftType: ['', Validators.required],
    registrationNumber: ['', Validators.required],
    owner: [false, Validators.requiredTrue]
  });
  beaconTypes = [BeaconType.LATCAS, BeaconType.OGNTRK, BeaconType.FLARM, BeaconType.ICAO];
  dataSource = new MatTableDataSource<Aircraft>([]);
  columnsToDisplay = [
    'beaconType',
    'deviceId',
    'aircraftType',
    'registrationNumber',
    'remove'
  ];
  subs = new SubSink();

  constructor(
    private fb: FormBuilder,
    private store: AircraftStore,
    private service: AircraftService,
    private query: AircraftQuery,
    private snackbar: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.subs.sink = this.service.getAircrafts().subscribe();
    this.subs.sink = this.aircrafts$.subscribe((v) => (this.dataSource.data = v));
  }

  lookup(): void {
    this.subs.sink = this.service.lookupAircrafts(this.newAircraft.value.deviceId).subscribe(
      value => this.newAircraft.setValue({ ...this.newAircraft.value, ...value }),
      _ => this.snackbar.open('Nincs találat!')
    );
  }

  registration(): void {
    this.newAircraft.markAllAsTouched();
    if (this.newAircraft.valid) {
      const aircraft = {
        ...this.newAircraft.value
      } as Aircraft;

      this.subs.sink = this.service.postAircraft(aircraft).subscribe(
        _ => {
          this.newAircraft.reset();
          this.subs.sink = this.service.getAircrafts().subscribe();
          this.snackbar.open('Sikeresen hozzáadva!')
          this.aircraftTab.selectedIndex = 1;
        },
        _ => this.snackbar.open('Sikertelen regisztráció!')
      );
    }
  }

  removeAircraft(aircraft: Aircraft): void {
    this.subs.sink = this.service.deleteAircraftById(aircraft.id).subscribe(
      _ => this.subs.sink = this.service.getAircrafts().subscribe(),
      _ => this.snackbar.open('Sikertelen!'));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
